import { DigitalDossier } from '../components/DigitalDossier';
import SignUpRequestDetail from '../components/SignUpRequestDetail/SignUpRequestDetail';
import { useUserContext } from '../contexts/UserContext';

export const HomePage = () => {
  const { isSignUpRequestApproved } = useUserContext();

  return (
    <>
      {isSignUpRequestApproved ? <DigitalDossier /> : <SignUpRequestDetail />}
    </>
  );
};

export default HomePage;
